"use client"
import { useParams, useNavigate } from "react-router-dom"
import  React,{ useEffect, useState } from 'react';
import { ArrowLeft, Phone, Mail, MapPin, User, Home,ChevronDown,ChevronRight  } from "lucide-react"
import axios from 'axios';

interface CustomerDetails {
  MyCompanyName: string;
  CorpName: string;
  StoreName: string;
  FirstName: string;
  LastName: string;
  CustAddress: string;
  City: string;
  StateAbbreviation: string;
  ZipCode: string;
  CustPhoneHome: string;
  CustPhoneWork: string;
  CustPhoneCell: string;
  Email: string;
}

 type CallHistory = {
  PocPon: string
  PocDate: string
  MessageDescription: string
  PocEntryId: string
}

interface ServiceDetail {
  PtpDescription: string;
  PurchaseTypeId: number;
  MTAbvr: string;
  ServiceAbvr: string | null;
  PONumber: string;
  PurchaseOrderDate: string;
  ScheduledDate: string;
  EmployeeApres: string;
  Waiver: boolean;
  HelperExtension: string;
  COD: string;
  CODReceivedBy: string;
  CourtesyCall: boolean;
  Amount: number;
  PurBillDate: string;
  CustomerId: number;
  CompanyId: number;
  PlanUrl: string;
  WaiverUrl: string;
  PoStatus: string;
  MTDesc: string;
}

interface MaterialDetail {
  Id: number;
  PONumber: string;
  StoreName: string;
  DueDate: string;
  ReceivedDate: string | null;
  Width: number;
  Length: number;
  CarrierName: string;
  MaterialDescription: string;
  Roll: string | null;
  SidMark: string;
  ReceivedNumber: string | null;
  QuantitySy: number;
} 

export default function CustomerDetails() {

  const { customerId } = useParams()
  const navigate = useNavigate()
  const [CustomerDetails, setCustomerDetails] = useState<CustomerDetails | null>(null);
  const [loading, setLoading] = useState(true);

  const [serviceDetails, setServiceDetails] = useState<ServiceDetail[]>([])
  const [materialDetail, setMaterialDetail] = useState<MaterialDetail[]>([])

  const [callHistory, setCallHistory] = useState<CallHistory[]>([])
  // const [openIndex, setOpenIndex] = useState<number | null>(null)
const [openIndex, setOpenIndex] = useState<string | null>(null)

  const [expandedRows, setExpandedRows] = useState<number[]>([]);

  const toggleExpand = (index: number) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  // const toggle = (index: number) => {
  //   setOpenIndex(openIndex === index ? null : index)
  // } 

  const toggle = (poNumber: string) => {
  setOpenIndex(openIndex === poNumber ? null : poNumber);
};

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        debugger;
        // const response = await axios.get<CustomerDetails[]>(`https://qaacsstoreapi.acsouth.com:443/api/custDetails?custid=${customerId}`);
        //const response = await axios.get<CustomerDetails[]>(`https://devprodapi.acsouth.com/api/custDetails?custid=${customerId}`);
        //PRODUCTION
        const response = await axios.get<CustomerDetails[]>(`https://acsstoreapi.acsouth.com/api/custDetails?custid=${customerId}`);
        setCustomerDetails(response.data[0]);
        debugger;

        //const callHistory = await axios.get<CallHistory[]>(`https://qaacsstoreapi.acsouth.com:443/api/pocallhistory?custid=${customerId}`);
        //const callHistory = await axios.get<CallHistory[]>(`https://devprodapi.acsouth.com/api/pocallhistory?custid=${customerId}`);
        //PRODUCTION
        const callHistory = await axios.get<CallHistory[]>(`https://acsstoreapi.acsouth.com/api/pocallhistory?custid=${customerId}`);
        setCallHistory(callHistory.data);
        debugger;

        //const serviceDetailsRes = await axios.get<ServiceDetail[]>(`https://qaacsstoreapi.acsouth.com:443/api/servicedetails?custid=${customerId}`);
        //const serviceDetailsRes = await axios.get<ServiceDetail[]>(`https://devprodapi.acsouth.com/api/servicedetails?custid=${customerId}`);
        //PRODUCTION
        const serviceDetailsRes = await axios.get<ServiceDetail[]>(`https://acsstoreapi.acsouth.com/api/servicedetails?custid=${customerId}`);
        setServiceDetails(serviceDetailsRes.data);
        debugger;

        // const materialDetailRes = await axios.get<MaterialDetail[]>(`https://qaacsstoreapi.acsouth.com:443/api/materialdetails?custid=${customerId}`);
        //const materialDetailRes = await axios.get<MaterialDetail[]>(`https://devprodapi.acsouth.com/api/materialdetails?custid=${customerId}`);
        //PRODUCTION
        const materialDetailRes = await axios.get<MaterialDetail[]>(`https://acsstoreapi.acsouth.com/api/materialdetails?custid=${customerId}`);
        setMaterialDetail(materialDetailRes.data);
        debugger;

      } catch (error) {
        console.error('Error fetching customer details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer()
  }, [customerId]);
 

  if (loading) return <p>Loading...</p>;
  if (!CustomerDetails) return <p>No customer data found.</p>;

  return (
    <div className="p-4 lg:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center mb-6">
          <button onClick={() => navigate(-1)} className="flex items-center text-blue-600 hover:text-blue-800 mr-4">
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-6">
            {/* Customer Info Section - unchanged */}
			<div className="bg-white rounded-lg shadow-md p-4 lg:p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Customer Information</h2>

                {/* Name and Address */}
                <div className="mb-4">
                  <div className="flex justify-between text-sm text-gray-500 mb-1">
                    <span>Name</span>
                    {/* <span>Address</span> */}
                  </div>
                  <div className="flex justify-between items-start gap-4">
                    <div className="flex items-center w-1/2">
                      <User className="h-5 w-5 text-gray-400 mr-2" />
                      <span className="text-base font-medium text-gray-900">
                        {CustomerDetails.FirstName} {CustomerDetails.LastName}
                      </span>
                    </div>
                    <div className="flex items-center w-1/2">
                      <MapPin className="h-5 w-5 text-gray-400 mr-2" />
                      <span className="text-base font-medium text-gray-900">
                        {CustomerDetails.CustAddress}, {CustomerDetails.StateAbbreviation} {CustomerDetails.ZipCode}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Phone Numbers */}
                <div className="mb-4">
                  <div className="text-sm text-gray-500 mb-1">Phone</div>
                  <div className="flex flex-wrap items-center gap-x-6 ml-0">
                    {CustomerDetails.CustPhoneHome && (
                      <div className="flex items-center text-base font-medium text-gray-900">
                        <Home className="h-4 w-4 text-gray-400 mr-1" />
                        <span>Home: {CustomerDetails.CustPhoneHome}</span>
                      </div>
                    )}
                    {CustomerDetails.CustPhoneWork && (
                      <div className="flex items-center text-base font-medium text-gray-900">
                        <Phone className="h-4 w-4 text-gray-400 mr-1" />
                        <span>Work: {CustomerDetails.CustPhoneWork}</span>
                      </div>
                    )}
                    {CustomerDetails.CustPhoneCell && (
                      <div className="flex items-center text-base font-medium text-gray-900">
                        <Phone className="h-4 w-4 text-gray-400 mr-1" />
                        <span>Cell: {CustomerDetails.CustPhoneCell}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Email */}
                <div>
                  <div className="text-sm text-gray-500 mb-1">Email</div>
                  <div className="flex items-center text-base font-medium text-gray-900">
                    <Mail className="h-4 w-4 text-gray-400 mr-2" />
                    <span>{CustomerDetails.Email}</span>
                  </div>
                </div>
              </div> 
           
          </div>

          {/* Scrollable Call History */}
          {/* Scrollable Call History */}
<div className="space-y-6 max-h-[400px] overflow-y-auto">
  <div className="bg-white rounded-lg shadow-md p-4 lg:p-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-3">Call History</h3>
    <div className="space-y-2">
      {Object.entries(
        callHistory.reduce<Record<string, CallHistory[]>>((acc, item) => {
          if (!acc[item.PocPon]) acc[item.PocPon] = [];
          acc[item.PocPon].push(item);
          return acc;
        }, {})
      ).map(([poNumber, entries]) => {
        // Sort entries for this PO number by PocDate descending
        const sortedEntries = [...entries].sort(
          (a, b) => new Date(b.PocDate).getTime() - new Date(a.PocDate).getTime()
        );

        return (
          <div key={poNumber} className="border border-gray-200 rounded-lg">
            <button
              onClick={() => toggle(poNumber)}
              className="w-full flex justify-between items-center text-left px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-lg"
            >
              <div>
                <div className="text-sm font-semibold text-gray-800">PO # {poNumber}</div>
              </div>
              <ChevronDown
                className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
                  openIndex === poNumber ? "rotate-180" : ""
                }`}
              />
            </button>

            {openIndex === poNumber && (
              <div className="px-4 pb-3 text-sm text-gray-700 space-y-2">
                {sortedEntries.map((item, idx) => (
                  <div key={idx} className="border-t pt-2">
                    <div className="text-gray-600">
                      <span className="font-medium">Date:</span>{" "}
                      {new Date(item.PocDate).toLocaleDateString()}
                    </div>
                    <div className="text-gray-600">
                      <span className="font-medium">Message:</span> {item.MessageDescription}
                    </div>
                    <div className="text-gray-600">
                      <span className="font-medium">Entered By:</span> {item.PocEntryId}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      {callHistory.length === 0 && (
        <div className="text-sm text-gray-500 italic">No call history available.</div>
      )}
    </div>
  </div>
</div>

          
        </div>
         {/* Job Details */}
            <div className="w-full bg-white rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">Job Details</h2>
             <div className="bg-white shadow rounded-lg overflow-x-auto w-full">
                 <table className="min-w-full table-auto text-sm text-left">
                    <thead className="bg-gray-100 text-gray-700">
                      <tr>
                        <th className="p-2 text-left"></th>
                        <th className="p-2 text-left">PO Number</th>
                        <th className="p-2 text-left">PO Type</th>
                        <th className="p-2 text-left">Material</th>
                        <th className="p-2 text-left">Scheduled</th>
                        <th className="p-2 text-left"></th>
                        <th className="p-2 text-left"></th>
                        <th className="p-2 text-left"> </th>
                      </tr>
                    </thead>
                    <tbody>
                      {serviceDetails.map((service, index) => {
                        const isExpanded = expandedRows.includes(index);
                        return (
                          <React.Fragment key={index}>
                            <tr className="border-b hover:bg-gray-50">
                              <td className="p-2 text-center">
                                <button onClick={() => toggleExpand(index)}>
                                  {isExpanded ? (
                                    <ChevronDown className="h-5 w-5 text-gray-500" />
                                  ) : (
                                    <ChevronRight className="h-5 w-5 text-gray-500" />
                                  )}
                                </button>
                              </td>
                              <td className="p-2">{service.PONumber}</td>
                              <td className="p-2">{service.PtpDescription}</td>
                              <td className="p-2">{service.MTDesc}</td>
                              <td className="p-2">{ !service.ScheduledDate || isNaN(new Date(service.ScheduledDate).getTime()) 
                                ? "Not Scheduled" 
                                : new Date(service.ScheduledDate).toLocaleDateString("en-US", { 
                                    year: "numeric", 
                                    month: "2-digit", 
                                    day: "2-digit" 
                                  })
                            }</td>
                              <td className="p-2 text-center">
 
                               {service.Waiver && service.WaiverUrl && service.WaiverUrl.trim() !== "" && (
                                <a href={service.WaiverUrl} target="_blank" rel="noreferrer">
                                  <button className="text-sm px-2 py-1 bg-blue-100 hover:bg-blue-200 text-blue-800 rounded">
                                    View Waiver
                                  </button>
                                </a>
                              )}
                              </td>
                              <td className="p-2">
                                <a href={service.PlanUrl} target="_blank" rel="noreferrer">
                                  <button className="text-sm px-2 py-1 bg-blue-100 hover:bg-blue-200 text-blue-800 rounded">
                                    View Plan
                                  </button>
                                </a>
                              </td>
                               <td className="p-2"> 

                                <span
                                  className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                                    service.PoStatus === "Paid"
                                      ? "bg-green-100 text-green-800"
                                      : service.PoStatus === "To be paid"
                                      ? "bg-yellow-100 text-yellow-800"
                                      : service.PoStatus === "Cancelled"
                                      ? "bg-red-100 text-red-800"
                                      : "bg-blue-100 text-blue-800"
                                  }`}
                                > 
                                {service.PoStatus}
                                </span>

                               </td>
                            </tr>
 
                             {isExpanded && (
                                <tr className="bg-gray-50 border-t">
                                  <td colSpan={8} className="p-4">
                                    <h3 className="text-md font-semibold mb-2 bg-blue-100 hover:bg-blue-200 text-blue-800">Material Details</h3>
                                    <table className="w-full text-sm border">
                                      <thead className="bg-gray-100 text-gray-700">
                                        <tr>
                                          <th className="p-2 text-left">Due Date</th>
                                          <th className="p-2 text-left">Rec. Date</th>
                                          <th className="p-2 text-left">Qty (SY)</th>
                                          <th className="p-2 text-left">Width</th>
                                          <th className="p-2 text-left">Length</th>
                                          <th className="p-2 text-left">Carrier</th>
                                          <th className="p-2 text-left">Material</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {materialDetail.filter(mat => mat.PONumber === service.PONumber).length > 0 ? (
                                          materialDetail
                                            .filter(mat => mat.PONumber === service.PONumber)
                                            .map((mat) => (
                                              <tr key={mat.Id} className="border-t">
                                                <td className="p-2">
                                                  {mat.DueDate ? new Date(mat.DueDate).toLocaleDateString() : "--"}
                                                </td>
                                                <td className="p-2">
                                                  {mat.ReceivedDate ? new Date(mat.ReceivedDate).toLocaleDateString() : "--"}
                                                </td>
                                                <td className="p-2">{mat.QuantitySy}</td>
                                                <td className="p-2">{mat.Width}</td>
                                                <td className="p-2">{mat.Length}</td>
                                                <td className="p-2">{mat.CarrierName}</td>
                                                <td className="p-2">{mat.MaterialDescription}</td>
                                              </tr>
                                            ))
                                        ) : (
                                          <tr>
                                            <td colSpan={7} className="text-sm text-gray-500 italic p-2">
                                              No material details available.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              )}

                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
              </div>
            </div>
      </div>
    </div>
  );
}
